import BannerComponent from "@/components/banner/main-banner.vue";
import CfssCertificationComponent from "@/components/cfss-certification/cfss-certification.component.vue";
import CfssMainContent from "@/components/cfss-main-content/cfss-main-content.component.vue";
import MoreInfromation from "@/components/more-information/more-information.vue";
import TestimonialPage from "@/components/testimonial-page/testimonial-page.vue";
import { Component, Vue } from "vue-property-decorator";
import { loginApi } from "@/providers/apis/login";
import { appConfigService } from "@/providers/services/app/app-config";
@Component({
  name: "home-page",
  components: {
    BannerComponent,
    TestimonialPage,
    CfssMainContent,
    CfssCertificationComponent,
    MoreInfromation,
  },
})
export default class HomePage extends Vue {
  public created() {
    loginApi
      .logInWithCredential(
        appConfigService.getClientId(),
        appConfigService.getClientKey(),
        "anonymous"
      )
      .then((data) => {
        console.log("dataItem", data);
        localStorage.setItem("anonymousToken", data.access_token);
      })
      .catch((error) => {
        console.log("ddddd", error);
      });
  }
}
